;(function () {
    window.addEventListener('load', () => {
        let months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ]
        let now = new Date()
        let thisMonth = months[now.getMonth()] // getMonth method returns the month of the date (0-January :: 11-December)
        let thisYear = now.getFullYear()

        let monthEls = document.querySelectorAll('.dyn-month')
        let yearEls = document.querySelectorAll('.dyn-year')

        monthEls.forEach(function (el, index) {
            el.textContent = thisMonth
        })

        yearEls.forEach(function (el, index) {
            el.textContent = thisYear
        })

        // Replace [DNYMTH] and [DNYYR] text placeholders anywhere in the page
        function replaceDatePlaceholders(root) {
            let walker = document.createTreeWalker(
                root,
                NodeFilter.SHOW_TEXT,
                null,
                false
            )
            let node
            while ((node = walker.nextNode())) {
                if (node.nodeValue.includes('[DNYMTH]')) {
                    node.nodeValue = node.nodeValue.replace(/\[DNYMTH\]/g, thisMonth)
                }
                if (node.nodeValue.includes('[DNYYR]')) {
                    node.nodeValue = node.nodeValue.replace(/\[DNYYR\]/g, thisYear)
                }
            }
        }

        // Run immediately for content already in the DOM
        replaceDatePlaceholders(document.body)

        // Watch for dynamically added content (e.g. Shopify sections)
        let observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                mutation.addedNodes.forEach(function (node) {
                    if (node.nodeType === Node.TEXT_NODE) {
                        if (node.nodeValue.includes('[DNYMTH]')) {
                            node.nodeValue = node.nodeValue.replace(/\[DNYMTH\]/g, thisMonth)
                        }
                        if (node.nodeValue.includes('[DNYYR]')) {
                            node.nodeValue = node.nodeValue.replace(/\[DNYYR\]/g, thisYear)
                        }
                    } else if (node.nodeType === Node.ELEMENT_NODE) {
                        replaceDatePlaceholders(node)
                    }
                })
            })
        })
        observer.observe(document.body, { childList: true, subtree: true })
    })
})()
